import { gql } from '../../__generated__/gql'

export const SYNTHESIZE_CHAT_AI_MESSAGE_MUTATION = gql(`
  mutation synthesizeChatAiMessage($threadId: Int!, $messageId: String!) {
    synthesizeChatAiMessage(input: { threadId: $threadId, messageId: $messageId }) {
      chatAiThreadMessage {
        id
        content
        author
        saved
        userReaction
        audioUrl
      }
    }
  }
`)
